<google-map width="100%" [height]="screenHeight" [options]="mapOptions" [center]="mapCenter">
	<map-marker
		#markerElem="mapMarker"
		*ngFor="let marker of markers"
		[position]="marker.position"
		[title]="marker.title"
		[options]="marker.markerOptions"
		(mapClick)="openInfo(markerElem, marker.info)"
	>
		<map-info-window
			(closeclick)="closeInfoWdw(markerElem)"
		>
			<div [innerHTML]="marker.info"></div>
		</map-info-window>
	</map-marker>
</google-map>